<template>
  <div class="basic-block block-about-slider-base" :style="styles">
    <div class="content-wrap">
      <div class="block-about-slider-base__inner">
        <img :src="`${path}somari_title01.png`" alt="" class="block-about-slider-base__headline-img" />
        
        <div class="block-about-slider-base__profile">
          <p class="block-about-slider-base__profile-text">
            生年月日と出生時間から、14パターンの「ねこタイプ」を診断。<br>
            心にためこんだ疲れや不安を外へと洗い流し、風通しを良くすることで、自然と自信を取り戻させてくれる占い。
          </p>
        </div>
      </div>

      <div class="block-about-slider-base__sliderarea">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item, idx) of sliderList" :key="idx">
            <img :src="item.src" class="block-about-slider-base__slider-card" :alt="item.alt" />
          </swiper-slide>
        </swiper>
      </div>

      <lp-base-button label="今すぐ無料で占う" design="fill" :color-scheme="colorScheme" @clicked="clicked" />
    </div>
    <img :src="`${path}line_ashiato01.png`" alt="" class="line-ashiato" />
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

export default {
  name: 'BlockAboutSlider',
  components: {
    LpBaseButton,
    swiper,
    swiperSlide,
  },
  props: {
    targetInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    colorScheme: {
      type: Object,
      default() {
        return {};
      },
    },
    lpId: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    styles() {
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      };
    },
  },
  methods: {
    clicked () {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-free-shindan-button`,
      })
      location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`)
    },
  },
  data() {
    return {
      path: '/static/img/recommend/lp/somarimone/products/',
      swiperOption: {
        speed: 600,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        loop: true,
      },
      sliderList: [
        {
          src: '/static/img/recommend/lp/somarimone/products/kekka_sample_01.png',
          alt: 'ゴールデンボンバー・鬼龍院翔さんは、考えすぎのイルカ',
        },
        {
          src: '/static/img/recommend/lp/somarimone/products/kekka_sample_02.png',
          alt: 'ジャニーズWEST・神山智洋さんは、さみしがりな龍',
        },
        {
          src: '/static/img/recommend/lp/somarimone/products/kekka_sample_03.png',
          alt: '大人気YouTuber・ゆきりぬさんは、わが道をいく孔雀',
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../../sass/commons/commonVariables.scss';

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

// 上限付きのレスポンシブなサイズを返す（$size は、width = 375px 時の大きさ）
@function responsive-size($size) {
  @return Min(($size / 375) * 100vw, $size * 1.3px );
}

.block-about-slider-base {
  position: relative;
  background: #fdfaf0;
  padding: 40px 0 40px;
  &__inner{
    position: relative;
    padding-top: 44px;
    @include mq('w375'){
      padding-top: 65px;
    }
    @include mq('w580'){
      padding-top: 100px;
    }
  }
  &__headline {
    font-weight: 600;
    font-size: responsive-size(20);
    line-height: 1.5;
    text-align: center;
    color: #32373f;
    margin: 0 0 8px;
  }
  &__headline-img {
    width: 100%;
    position: absolute;
    max-width: 100%;
    top: -100px;
    @include mq('w375'){
      top: -112px;
    }
    @include mq('w580'){
      top: -140px;
    }
  }
  &__profile {
    display: flex;
    align-items: center;
    max-width: 480px;
    margin: 0 auto 16px;
  }
  &__profile-img {
    flex: 0 1 160px;
    width: responsive-size(160);
    max-width: 200px;
  }
  &__profile-text {
    flex: 1 1 auto;
    //margin: -3% 0 0;
    font-weight: 300;
    font-size: 14px;
    line-height: 21px;
    color: #32373f;
    padding: 0 20px;
  }
  &__sliderarea {
    margin: 0 0 24px;
    .swiper-slide {
      padding: 0 20px;
    }
  }
  &__slider-card {
    display: block;
    width: 100%;
    max-width: 480px;
    margin: auto;
  }
  &__free {
    font-weight: 600;
    font-size: responsive-size(20);
    line-height: 1.5;
    text-align: center;
    color: $l_col_keycolor;
    margin: 0 0 24px;
  }
  .line-ashiato{
    position: absolute;
    bottom: -60px;
    z-index: 1;
    width: 100%;
    @include mq('w580'){
      bottom: -115px;
    }
  }
  .baseButton {
    width: 72%;
    max-width: 340px;
    margin: auto;
    /deep/ {
      .baseButton__button {
        font-size: responsive-size(18);
        font-weight: 600;
        padding: 13.5px 32px;
        min-width: auto;
      }
    }
  }
  .heightbox{
    min-height:120px ;
    max-height: 215px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/somarimone/partials/BlockAboutSlider.vue